<script>
export default {
    name: "ViewLabResults",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
        };
    },

    props: {

        investigation: Object,
        results: Object,
        imageResults: Array,
        showModal: Boolean,
    },

    methods: {

        printLabResult() {

            window.open(`/medical-file/lab-result/print/${this.$route.params.patientID}/${this.investigation.code}`, '_blank', `LabResultPrint`, "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
    }
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-11/12 sm:w-full">
      <template v-slot:title>
        <h5 class="font-medium text-sm">View investigation Results</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full flex flex-wrap -m-3">
            <div class="w-full flex flex-wrap p-1 bg-gray-300 my-1">
                <div class="md:w-1/3 sm:w-1/2">
                    <h5 class="text-sm"><span class="font-medium">Investigation:</span> {{ investigation.investigation }}</h5>
                </div>
                <div class="md:w-1/3 sm:w-1/2">
                    <h5 class="text-sm"><span class="font-medium">Requested By:</span> {{ investigation.requestedBy || `-` }}</h5>
                </div>
                <div class="md:w-1/3 sm:w-1/2">
                    <h5 class="text-sm"><span class="font-medium">Done:</span> {{ investigation.done ? `Yes` : `No` }}</h5>
                </div>
            </div>
            <ul class="flex border-b-2 border-gray-500">
              <li class="-mb-px mr-1">
                  <a href="javascript:void(0)" @click.prevent="active=0" 
                    class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap" 
                    :class="active == 0 ? activeClass : inActiveClass">Component Results</a>
              </li>
              <li class="-mb-px mr-1">
                  <a href="javascript:void(0)" @click.prevent="active=1"
                    class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
                    :class="active == 1 ? activeClass : inActiveClass">Images</a>
              </li>
            </ul>
            <div class="w-full" v-if="active==0">
                <div class="w-full overflow-auto">
                    <table class="table table-hover">
                        <thead class="bg-blue-500 text-sm text-white">
                            <tr class="w-full flex">
                                <th class="p-tiny w-2/5">Component</th>
                                <th class="p-tiny w-1/5">Value</th>
                                <th class="p-tiny w-1/5">Max Value</th>
                                <th class="p-tiny w-1/5">Min Value</th>
                            </tr>
                        </thead>
                        <tbody 
                            class="bg-gray-100 flex flex-col items-center text-xs overflow-auto" 
                            style="max-height:25vh;">
                            <tr class="w-full flex" v-for="(result,idx) in results.componentResults" :key="idx">
                                <td class="p-tiny w-2/5">{{ result.component }}</td>
                                <td class="p-tiny w-1/5"><span class="ml-2">{{ result.resultValue }}</span></td>
                                <td class="p-tiny w-1/5"><span class="ml-2">{{ result.minValue }}</span></td>
                                <td class="p-tiny w-1/5"><span class="ml-2">{{ result.maxValue }}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="w-full overflow-auto bg-gray-200" style="max-height:40vh;">
                    <span v-html="investigation.memo"></span>
                </div>
            </div>
            <div class="w-full" v-if="active==1">
                <div class="w-full flex flex-col">
                    <div class="flex-1 p-tiny" v-for="(result, idx) in imageResults" :key="idx">
                        <iframe 
                            height="1300" width="1400" 
                            :src="`data:application/pdf;base64,${result.investigationImage}`" 
                            alt="lab test">
                        </iframe>
                    </div>
                </div>
            </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-sm btn-primary text-xs rounded mr-8" @click.prevent="printLabResult"><i class="fa fa-print"></i> Print</button>
        <button class="btn-danger btn-sm text-xs rounded" @click="$emit(`closeModal`)"><i class="fa fa-times"></i> Cancel</button>
      </template>
    </tail-modal>
</template>